<template>
  <div>
    <div class="wrapper">
      <div class="scroller" v-if="hasData">
        <div>
          <div v-for="(group, g) in groups" :key="g" class="cards-group">
            <div class="header">{{group.header}}</div>
            <card v-for="(card, i) in group.cards"
                  :key="i"
                  :id="`card-${i}`"
                  :card="card" />
          </div>
        </div>
      </div>
      <div class="empty-holder" v-if='this.loading'>
        <span class="updates-loading" /> Loading recent updates ...
      </div>

      <div class="empty-holder" v-if='!this.loading && !hasData'>
        <i class="fal fa-calendar-alt"/> 
        <span>
        <p class="bold">No Recent Updates</p>
        <p class="light">No activity in the past two weeks</p>
        </span>
      </div>
    </div>
  </div>
</template>


<script>
  import card from './card'
  import { initScrollbar } from '../../helpers/scrollbarHelper.js'
  import { EventBus } from '@/event-bus'

  export default {
    alias: 'recent-updates-wdg-cmp',

    props: { widget: Object },

    data() {
      return {
        cards: [],
        loading: false
      }
    },

    computed: {
      groups() {
        var result = []
        var now = new Date()
        var today1 = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        var today2 = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999)
        var yesterday1 = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1)
        var yesterday2 = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 23, 59, 59, 999)
        var twoDaysAgo1 = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 2)
        var twoDaysAgo2 = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 2, 23, 59, 59, 999)
        var threeDaysAgo1 = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 3)
        var threeDaysAgo2 = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 3, 23, 59, 59, 999)
        var earlier1 = new Date(1, 1, 1)
        var earlier2 = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 4, 23, 59, 59, 999)

        this.pushIfPresent(result, this.getInRange('Today', today1, today2))
        this.pushIfPresent(result, this.getInRange('Yesterday', yesterday1, yesterday2))
        this.pushIfPresent(result, this.getInRange('2 days ago', twoDaysAgo1, twoDaysAgo2))
        this.pushIfPresent(result, this.getInRange('3 days ago', threeDaysAgo1, threeDaysAgo2))
        this.pushIfPresent(result, this.getInRange('Older', earlier1, earlier2))

        return result
      },

      hasData() {
        if ((this.cards !== null) && (this.cards.length > 0)) return true
        else return false
      }
    },

    created() {
      this.loading = true

      this.api.get(this.widget.endPoint, {})
        .then(r => {
          this.cards = r.data
        })
        .finally(() => {
          this.loading = false
          if (this.hasData) {
            this.$nextTick(() => {
              EventBus.$emit('updateWidgetHeightSimple', {
                wId: this.widget.id,
                height: this.$el.clientHeight + 6,
                explicitS: this.cards.length === 1 ? 2 : null
              })

              if (this.cards.length > 7) {
                this.$el.querySelector('.scroller').style.height = '640px'
                initScrollbar(this, '.scroller')
              }
            })
          }
        })
    },

    methods: {
      pushIfPresent(result, group) {
        if (group.cards.length > 0) {
          result.push(group)
        }
      },

      getInRange(header, startDate, endDate) {
        var result = []

        for (var i = 0, n = this.cards.length; i < n; i++) {
          if (global.moment(this.cards[i].Date).isBetween(startDate, endDate)) {
            result.push(this.cards[i])
          }
        }

        return {
          header: header,
          cards: result
        }
      }
    },

    components: { card }
  }

</script>

<style lang="scss" scoped>
  @import "~@/assets/sass/_variables.scss";

  .wrapper {
    min-height: 30px;
    height: auto;
    max-height: 640px;
  }

  .scroller {
    min-height: 30px;
    height: auto;
    position: relative;
    max-height: 640px;
    overflow-y: hidden;
  }

  .empty-holder {
    text-align: center;
  }
  .updates-loading{
    margin-top: 25px;
    margin-left: 50px;
  }

  div.empty-holder {
    position: absolute;
    left: 160px;
    i.fal{
      font-size: 1.7rem;
      height: 50px;
      width: 50px;
      padding-top:12px;
      padding-left:1px;
      background-color:#f2f2f2;
      border-radius: 50%;
      display: inline-block;
      margin-right: 10px;
    }
    text-align: center;
    vertical-align: middle;
    margin-top: 0px;
    color: #9c9c9c;
    font-size: 0.96em;
    font-weight: 600;
    span{
      text-align: left;
      display: inline-block;
      p{
        line-height: 0.4rem;
        display:block;
        &.bold{
          font-weight: 650
        }
        &.light{
          font-size: 0.8rem;
          font-weight: 200;
        }
    }
  }}

  .cards-group {
    padding: 0 10px;
  }

  .header {
    font-size: $font-size-small;
    text-transform: uppercase;
    font-weight: 600;
    padding: 4px 0;

    @include theme {
      border-bottom: 1px solid v(background-light);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/widgets/RecentUpdates/index.vue